import { render, staticRenderFns } from "./TheRadarBadge.vue?vue&type=template&id=b6587454&scoped=true&"
import script from "./TheRadarBadge.vue?vue&type=script&lang=js&"
export * from "./TheRadarBadge.vue?vue&type=script&lang=js&"
import style0 from "./TheRadarBadge.vue?vue&type=style&index=0&id=b6587454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6587454",
  null
  
)

export default component.exports